'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = tracking;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getTrackingId(communityContentType, communityContentRelatedId) {
  return communityContentType + '-' + communityContentRelatedId;
}

function getTracking(data) {
  return {
    onImpressionTrackingPixels: data.onImpressionTrackingPixels,
    onPlayTrackingPixels: data.onPlayTrackingPixels,
    onReactionTrackingPixels: data.onReactionTrackingPixels,
    onVideoFirstQuartileTrackingPixels: data.onVideoFirstQuartileTrackingPixels,
    onVideoMidpointQuartileTrackingPixels: data.onVideoMidpointQuartileTrackingPixels,
    onVideoThirdQuartileTrackingPixels: data.onVideoThirdQuartileTrackingPixels,
    onVideoCompleteTrackingPixels: data.onVideoCompleteTrackingPixels,
    onShareTrackingPixels: data.onShareTrackingPixels
  };
}

function tracking() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var newState = null;
  switch (action.type) {
    case _actionTypes.RECEIVE_COMM_CONTENT_METADATA:
      var _action$payload = action.payload,
          communityContentType = _action$payload.communityContentType,
          communityContentRelatedId = _action$payload.communityContentRelatedId,
          responseData = _action$payload.responseData;

      return _extends({}, state, _defineProperty({}, getTrackingId(communityContentType, communityContentRelatedId), getTracking(responseData)));
    case _actionTypes.ADD_FEED_ITEMS:
      newState = _extends({}, state);
      if (action.payload.feedItems) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = action.payload.feedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var feedItem = _step.value;

            if (feedItem.content.communityContentId) {
              var _feedItem$content$com = feedItem.content.communityContentId,
                  type = _feedItem$content$com.type,
                  relatedId = _feedItem$content$com.relatedId;

              newState[getTrackingId(type, relatedId)] = getTracking(feedItem);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return newState;
    case _actionTypes.RECEIVE_MINI_PROFILE:
    case _actionTypes.RECEIVE_USER_TIMELINE:
      newState = _extends({}, state);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = action.payload.response.feedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _feedItem = _step2.value;

          if (_feedItem.content.communityContentId) {
            var _feedItem$content$com2 = _feedItem.content.communityContentId,
                _type = _feedItem$content$com2.type,
                _relatedId = _feedItem$content$com2.relatedId;

            newState[getTrackingId(_type, _relatedId)] = getTracking(_feedItem);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return newState;
    default:
      return state;
  }
}